import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid, Button,
  Table,
  CircularProgress,
  TableBody,
  TableCell,
  TableContainer, Menu, MenuItem,
  TableHead,
  TableRow,
  Paper,
  Avatar, DialogActions,
  DialogContent,
  TablePagination, ListItemIcon,
  ListItemText, TextField, Select, InputLabel, FormControl
} from "@mui/material";
import { useNavigate } from "react-router-dom";
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {
  Dialog,
  DialogTitle,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GlobalStyles } from "@mui/system";
import GroupIcon from "@mui/icons-material/Group";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { IoIosPeople } from "react-icons/io";
import { BsPersonCheckFill } from "react-icons/bs";
import { BsFillPersonXFill } from "react-icons/bs";
import { format } from "date-fns"; // Import the format function
import { useAuth } from "../../AuthProvider";



import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";



const baseUrl = process.env.REACT_APP_API_BASE_URL;
const Packages = () => {

  const [organization, setOrganization] = useState([]);
  const [loader, setLoader] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const [newOrgId, setNewOrgId] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);
  const [loading, setLoading] = useState(false);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };

  const [open, setOpen] = useState(false);
  // const [formData, setFormData] = useState({});

  const handleOpen = (row) => {
    setNewOrgId(row.orgId)
    setFormData(row);
    setOpen(true);
  };

  const handleDialogClose = () => {
    setOpen(false);
    setFormData({});
  };



const fetchAllOrganizationsList = async () => {
  try {
    setLoader(true);
    const response = await fetch(`${baseUrl}/api/superAdmin/getAllOrganisationList`);

    if (!response.ok) {
      console.warn("Organization List fetch failed with status:", response.status);
      setOrganization([]); // fallback to empty data
      return;
    }

    const data = await response.json();
    setOrganization(data || []);
  } catch (error) {
    console.error("Failed to fetch Data", error);
    setOrganization([]); // fallback to empty data
  } finally {
    setLoader(false);
  }
};


useEffect(() => {
  fetchAllOrganizationsList();
}, []);
  const today = new Date().toISOString().split("T")[0];

  const [formData, setFormData] = useState({
    packageExpireDate: today,          // Plan Expiry Date
    registeredDate: today,    // Plan Registered Date
    status: "ACTIVE",         // Default status
    // other fields...
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


// const handleSave = async () => {
//   const { packageExpireDate, status ,plan,feature} = formData;
//   const queryParams = new URLSearchParams({
//     packageExpireDate: packageExpireDate || "",
//     status: status || "",
//     plan: plan || "",
//     feature: feature || ""
//   }).toString();

//   setLoading(true); // start loading

//   try {
//     const response = await fetch(
//       `${baseUrl}/api/superAdmin/updateOrganisationStatusAndExpiry/${newOrgId}?${queryParams}`,
//       {
//         method: "PATCH",
//       }
//     );

//     if (response.ok) {
//       toast.success("Status and Expiry updated successfully!", { autoClose: 1000 });

//       handleDialogClose();
//         await fetchAllOrganizationsList();
//     } else {
//       const errorText = await response.text();
//       toast.error(errorText || "Failed to update organisation status.", { autoClose: 1000 });
//     }
//   } catch (error) {
//     console.error("Error updating organisation status:", error);
//     toast.error("An error occurred while updating status.", { autoClose: 2000 });
//   } finally {
//     setLoading(false); // stop loading
//   }
// };

const handleSave = async () => {
  const { packageExpireDate, status, plan, feature } = formData;

  const queryParams = new URLSearchParams({
    packageExpireDate: packageExpireDate || "",
    status: status || "",
    plan: plan || "",
    featureEnable: feature || ""
  }).toString();

  setLoading(true);

  try {
    const response = await fetch(
      `${baseUrl}/api/superAdmin/updateOrganisationStatusAndExpiry/${newOrgId}?${queryParams}`,
      {
        method: "PATCH",
      }
    );

    const responseText = await response.text(); // read response either way

    if (response.ok) {
      toast.success(responseText || "Status and Expiry updated successfully!", {
        autoClose: 1000,
      });
      handleDialogClose();
      await fetchAllOrganizationsList();
    } else {
      toast.error(responseText || "Failed to update organisation status.", {
        autoClose: 1000,
      });
    }
  } catch (error) {
    console.error("Error updating organisation status:", error);
    toast.error("An error occurred while updating status.", { autoClose: 2000 });
  } finally {
    setLoading(false);
  }
};






  const filteredResults = organization.filter((item) => {
    const query = searchQuery.toLowerCase();

    const schoolName = item.schoolName?.toLowerCase() || "";
    const contactNumber = item.primaryContact?.toString().toLowerCase() || "";
    const joinDate = item.joinDate?.toString().toLowerCase() || "";
    const boardAffiliation = item.boardAffiliation?.toLowerCase() || "";
    const feature = item.feature?.toLowerCase() || "";
    const plan = item.plan?.toLowerCase() || "";
    const schoolEmailId = item.schoolEmailId?.toLowerCase() || "";
    const schoolAddress = item.schoolAddress?.toLowerCase() || "";

    return (
      schoolName.includes(query) ||
      contactNumber.includes(query) ||
      joinDate.includes(query) ||
      boardAffiliation.includes(query) ||
      feature.includes(query) ||
      plan.includes(query) ||
      schoolEmailId.includes(query) ||
      schoolAddress.includes(query)
    );
  });





  const exportToExcel = () => {
    const orgData = filteredResults.map(
      ({
        orgId,
        schoolName,
        schoolEmailId,
        primaryContact,
        secondaryContact,
        boardAffiliation,
        schoolAddress,
        city,
        state,
        plan,
        feature,
        studentLimit,
        totalPresentStudents,
        totalPresentEmployees,
        totalPrincipals,
        joinDate,
        status,
      }) => ({
        OrgID: orgId,
        SchoolName: schoolName,
        SchoolEmail: schoolEmailId,
        PrimaryContact: primaryContact,
        SecondaryContact: secondaryContact,
        BoardAffiliation: boardAffiliation,
        SchoolAddress: schoolAddress,
        City: city,
        State: state,
        Plan: plan,
        Feature: feature,
        StudentLimit: studentLimit,
        TotalPresentStudents: totalPresentStudents,
        TotalPresentEmployees: totalPresentEmployees,
        TotalPrincipals: totalPrincipals,
        JoinDate: joinDate,
        Status: status,
      })
    );

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Organizations");

    worksheet.columns = Object.keys(orgData[0]).map((key) => ({
      header: key.replace(/([A-Z])/g, " $1").trim(),
      key,
      width: 25,
    }));

    orgData.forEach((row) => {
      worksheet.addRow(row);
    });

    // Style header row
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "87CEEB" },
      };
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "RegisteredOrganizationsList.xlsx";
      link.click();
    });

    handleExportClose();
  };






  return (
    <Box p={2} marginTop={2}>

      <Box mt={5}>
        <Card
          sx={{
            backgroundColor: "white",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
          }}
        >
          <Typography sx={{ fontSize: 18, padding: 1, textAlign: "center" }}>
            <strong style={{ padding: 12 }}>Registered Organizations Package Details</strong>
          </Typography>


          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >






            <TextField
              label="Search Organizaion Details"
              variant="outlined"
              size="small"
              style={{ width: '200px', marginLeft: '15px' }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              fullWidth
            />


            <Box>
              <Button
                variant="contained"
                onClick={handleExportClick}
                sx={{
                  backgroundColor: "#3C3972",
                  fontWeight: 'bold',
                  color: "#fff",
                  "&:hover": { backgroundColor: "#3C3972" },

                  marginBottom: 2,
                  marginRight: 2,
                }}
                startIcon={<PresentToAllIcon />}
              >
                Export
              </Button>

              <Menu
                anchorEl={exportAnchorEl}
                open={isExportMenuOpen}
                onClose={handleExportClose}
                sx={{
                  "& .MuiPaper-root": {
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                  },
                }}
              >
                <MenuItem
                  onClick={exportToExcel}
                  sx={{
                    color: "#3f51b5",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#e8f0fe",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#00796b" }}>
                    <SimCardDownloadIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Excel"
                    sx={{ fontWeight: "bold", color: "#00796b" }}
                  />
                </MenuItem>

                {/* <MenuItem
                  onClick={exportToPDF}
                  sx={{
                    color: "#d32f2f",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#fdecea",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#d32f2f" }}>
                    <PictureAsPdfIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="PDF"
                    sx={{ fontWeight: "bold", color: "#d32f2f" }}
                  />
                </MenuItem> */}
                {/* 
                <MenuItem
                  onClick={exportToJSON}
                  sx={{
                    color: "#388e3c",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#e8f5e9",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#6a1b9a" }}>
                    <FilePresentIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="JSON"
                    sx={{ fontWeight: "bold", color: "#6a1b9a" }}
                  />
                </MenuItem> */}
              </Menu>


            </Box>
          </Box>













          <CardContent>
            <GlobalStyles
              styles={{
                ".custom-sidebar-scrollbar": {
                  scrollbarWidth: "thin", // For Firefox
                  scrollbarColor: "grey #e0e0e0",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                  width: "6px", // For WebKit-based browsers
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                  background: "#f1f1f1", // Track color
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                  backgroundColor: "grey", // Thumb color
                  borderRadius: "10px",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555",
                },
              }}
            />
            <TableContainer
              component={Paper}
              style={{ maxHeight: "500px", overflowY: "auto" }}
              className="custom-sidebar-scrollbar"
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {[
                      "S.No",
                      "Registered Date",
                      "Organization Name",
                      "Feature",
                      "Plan",
                      "Principals",
                      "Students",
                      "Employees",
                      "Status",
                      "Action",
                    ].map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          backgroundColor: "#fff9c4",
                          fontWeight: "Bold",
                          fontSize: "14px",
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loader ? (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                        >
                          <CircularProgress />
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            Loading Data...
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : filteredResults.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No data available
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredResults.map((employee, index) => (
                      <TableRow
                        key={employee.id}
                        sx={{
                          backgroundColor: "white",
                          transition: "background-color 0.3s",
                          "&:hover": { backgroundColor: "#f5f5f5" }, // Hover effect

                        }}
                      >
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "4px",
                            textAlign: "Center", // left-aligned looks better for long text
                            maxWidth: "100px", // increase width if needed
                            minWidth: "40px",
                            whiteSpace: "normal",  // allow wrapping
                            // wordBreak: "break-word", // break long words
                            color: "black",
                            fontSize: "13px",
                          }}
                        >
                          {index + 1}
                        </TableCell>


                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "4px",
                            textAlign: "Center", // left-aligned looks better for long text
                            maxWidth: "150px", // increase width if needed
                            minWidth: "100px",
                            color: "black",
                            fontSize: "13px",
                          }}
                        >
                          {employee.joinDate}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "4px",
                            textAlign: "Center", // left-aligned looks better for long text
                            maxWidth: "150px", // increase width if needed
                            minWidth: "100px",
                            whiteSpace: "normal",  // allow wrapping
                            wordBreak: "break-word", // break long words
                            color: "black",
                            fontSize: "13px",
                          }}
                        >
                          {employee.schoolName}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "4px",
                            textAlign: "Center", // left-aligned looks better for long text
                            maxWidth: "150px", // increase width if needed
                            minWidth: "100px",
                            whiteSpace: "normal",  // allow wrapping
                            wordBreak: "break-word", // break long words
                            color: "black",
                            fontSize: "13px",
                          }}

                        >
                          {employee.feature || "NA"}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                            color: "black",
                            fontSize: '13px'
                          }}
                        >
                          {employee.plan || "NA"}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                            color: "black",
                            fontSize: '13px'
                          }}
                        >
                          {employee.totalPrincipals || "NA"}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "4px",
                            textAlign: "Center", // left-aligned looks better for long text
                            maxWidth: "150px", // increase width if needed
                            minWidth: "100px",
                            whiteSpace: "normal",  // allow wrapping
                            wordBreak: "break-word", // break long words
                            color: "black",
                            fontSize: "13px",
                          }}
                        >
                          {employee.totalPresentStudents || "NA"}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "4px",
                            textAlign: "Center", // left-aligned looks better for long text
                            maxWidth: "150px", // increase width if needed
                            minWidth: "100px",
                            whiteSpace: "normal",  // allow wrapping
                            wordBreak: "break-word", // break long words
                            color: "black",
                            fontSize: "13px",
                          }}
                        >
                          {employee.totalPresentEmployees || "NA"}
                        </TableCell>
                        {/* <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "4px",
                            textAlign: "Center", // left-aligned looks better for long text
                            maxWidth: "150px", // increase width if needed
                            minWidth: "100px",
                            whiteSpace: "normal",  // allow wrapping
                            wordBreak: "break-word", // break long words
                            color: "black",
                            fontSize: "13px",
                          }}
                        >
                          {employee.status || "NA"}
                        </TableCell> */}
                        <TableCell
                                              sx={{
                                                borderRight: "1px solid #ddd",
                            padding: "4px",
                            textAlign: "Center", // left-aligned looks better for long text
                            maxWidth: "150px", // increase width if needed
                            minWidth: "100px",
                            whiteSpace: "normal",  // allow wrapping
                            wordBreak: "break-word", // break long words
                            color: "black",
                            fontSize: "13px",
                                              }}
                                            >
                                              <Button
  variant="contained"
  style={{
    backgroundColor: employee.status === 'ACTIVE' ? '#65C63E' : '#e53935', // custom red
    color: '#fff',
    fontWeight: 'bold',
    textTransform: 'none',
    borderRadius: '20px',
  }}
>
  {employee.status || 'N/A'}
</Button>

                                            </TableCell>

                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "4px",
                            // whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            textAlign: "center",
                          }}
                        >
                          <Button
                            type="button"
                            // onClick={handleOpen}
                            onClick={() => handleOpen(employee)} // Pass the row data to handleOpen
                            sx={{
                              backgroundColor: "blue",
                              // backgroundColor: "#1976d2",
                              color: "white",
                              fontSize: "0.6rem", // Reduces the font size
                              fontWeight:'bold',
                              // padding: "5px 10px",  // Reduces the padding
                              height: "25px", // Reduces the height
                              "&:hover": {
                                backgroundColor: "blue",
                              },
                            }}
                          // disabled={row.romanNumberClass === "Class-X" || row.romanNumberClass === "Inter-2nd-Year"}
                          >
                            Change Plan
                          </Button>
                        </TableCell>

                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>



            {/* Dialog for Change Plan Row Data */}
            <Dialog open={open} onClose={handleDialogClose} fullWidth maxWidth="sm">
              <DialogTitle variant="h4">Change Plan</DialogTitle>
              <DialogContent>

                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      margin="dense"
                      name="schoolName"
                      label="Organization Name"
                      value={formData.schoolName || ""}
                      // onChange={handleChange}
                      disabled
                      InputProps={{
                        style: { backgroundColor: "#f0f0f0", color: "#6c757d",fontWeight:'bold' }, // Light gray background and muted text color
                      }}
                    />
                  </Grid>

               
 <Grid item xs={6}>
                <TextField
                  fullWidth
                  type="date"
                  margin="dense"
                  name="joinDate"
                  label="Package Registered Date"
                  value={formData.joinDate || ""}
                  // onChange={handleChange}
                  disabled
                  InputProps={{
                    style: { backgroundColor: "#f0f0f0", color: "#6c757d",fontWeight:'bold'  }, // Light gray background and muted text color
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  type="date"
                  margin="dense"
                  name="packageExpireDate"
                  label="Package Expiry Date"
                  value={formData.packageExpireDate || ""}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
</Grid>
<Grid item xs={6}>

                <FormControl fullWidth sx={{ marginTop: '5px' }}>
                  <InputLabel id="school-fee-label">Status</InputLabel>
                  <Select
                    labelId="school-fee-label"
                    name="status"
                    value={formData.status || ""}
                    onChange={handleChange}
                    label="Status"
                  >
                    <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                    <MenuItem value="INACTIVE">INACTIVE</MenuItem>
                  </Select>
                </FormControl>
              </Grid>



              <Grid item xs={6}>

                <FormControl fullWidth sx={{ marginTop: '5px' }}>
                  <InputLabel id="school-fee-label">Features</InputLabel>
                  <Select
                    labelId="school-fee-label"
                    name="feature"
                    value={formData.feature || ""}
                    onChange={handleChange}
                    label="Features"
                  >
                    <MenuItem value="LITE">LITE</MenuItem>
                    <MenuItem value="CORE">CORE</MenuItem>
                    <MenuItem value="ULTRA">ULTRA</MenuItem>
                    
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6}>

                <FormControl fullWidth sx={{ marginTop: '5px' }}>
                  <InputLabel id="school-fee-label">Plan</InputLabel>
                  <Select
                    labelId="school-fee-label"
                    name="plan"
                    value={formData.plan || ""}
                    onChange={handleChange}
                    label="Plan"
                  >
                    <MenuItem value="SILVER">SILVER</MenuItem>
                    <MenuItem value="GOLD">GOLD</MenuItem>
                    <MenuItem value="PLATINUM">PLATINUM</MenuItem>
                    <MenuItem value="DIAMOND">DIAMOND</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              
 </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleDialogClose} color="primary" variant="outlined">
                  Cancel
                </Button>
                <Button
  onClick={handleSave}
  color="success"
  variant="outlined"
  disabled={loading}
  sx={{
    backgroundColor: "#3C3972",
    color: "white",
    fontSize: "0.8rem",
    height: "35px",
    "&:hover": {
      backgroundColor: "#3C3972",
    },
    opacity: loading ? 0.7 : 1,
  }}
>
  {loading ? (
    <CircularProgress size={20} sx={{ color: "white" }} />
  ) : (
    "Save"
  )}
</Button>

              </DialogActions>
            </Dialog>

          </CardContent>
        </Card>
      </Box>


      <ToastContainer />
    </Box>
  );
};


export default Packages;